import styled from 'styled-components';

export const AccountPurchasePageContainer = styled.main`
    .valid.bloc {
        display: inline-block;
    }
    .valid.header {
        background-color: ${props => props.theme.accountValidCashbackBlockColor};
        color: ${props => props.theme.accountValidCashbackTextColor};
        font-weight: ${props => props.theme.boldWeight};
        height: 50px;
        padding-top: 15px;
        text-align: center;
        width: 400px;
        border-radius: 25px 25px 0 0;
    }
    .valid.footer {
        border: 1px solid ${props => props.theme.accountValidCashbackBlockColor};
        color: ${props => props.theme.black};
        font-size: 20px;
        font-weight: ${props => props.theme.boldWeight};
        height: 60px;
        padding-top: 12px;
        text-align: center;
        width: 400px;
        border-radius: 0 0 25px 25px;
    }
    .croixResumeCagnotte {
        display: inline-block;
        margin-left: 82px;
        margin-right: 83px;
        position: relative;
        top: -20px;
        svg {
            .cls-1 {
                fill: ${props => props.theme.accountSvgCircleColor};
            }
            .cls-2 {
                fill: ${props => props.theme.accountSvgCrossColor};
            }
        }
    }
    .pending.bloc {
        display: inline-block;
    }
    .pending.header {
        background-color: ${props => props.theme.accountWaitingCashbackBlockColor};
        color: ${props => props.theme.accountWaitingCashbackTextColor};
        font-weight: ${props => props.theme.boldWeight};
        height: 50px;
        padding-top: 15px;
        text-align: center;
        width: 400px;
        border-radius: 25px 25px 0 0;
    }
    .pending.footer {
        border: 1px solid ${props => props.theme.accountWaitingCashbackBlockColor};
        font-size: 20px;
        font-weight: ${props => props.boldWeight};
        color: ${props => props.theme.black};
        height: 60px;
        padding-top: 12px;
        text-align: center;
        width: 400px;
        border-radius: 0 0 25px 25px;
    }

    .buttonWrapper {
        margin-top: 30px;
        text-align: center;
    }

    .totalCagnotte {
        color: ${props => props.theme.accountTotalCashbackTextColor};
        font-size: 20px;
        margin-bottom: 10px;
        margin-top: 35px;
    }

    .totalCagnotte span {
        font-weight: ${props => props.theme.boldWeight};
    }
    .ligneForLegende {
        border-bottom: 1px solid ${props => props.theme.accountCashbackLegendLineColor};
        margin: 0 10px;
        padding: 30px 10px;
    }
    .legende {
        padding: 0 20px;
    }
    .legendeLb {
        font-size: 12px;
        margin: 20px 0;
    }
    .legendeLb svg {
        margin-right: 20px;
    }
    .legendeLbMulti svg {
        align-self: flex-start;
    }
    .legendeLb p {
        margin: 0;
        width: 90%;
    }
    .legendeLb span {
        color: ${props => props.theme.accountCashbackHistoryLegendStateColor};
        font-weight: ${props => props.theme.boldWeight};
    }
    .inbl {
        display: inline-block;
        vertical-align: top;
    }
    .colorSpan {
        color: ${props => props.theme.accountCashbackHistoryLegendStateColor};
    }

    .stateTxt {
        margin-left: 3px;
    }

    .form-submit-container {
        text-align: center;
    }

    /* tablette et mobile */
    @media screen and (max-width: ${props => props.theme.large}) {
        .resumeCagnotte > * {
            display: block;
        }
        .croixResumeCagnotte {
            margin: 20px 0;
            top: initial;
            text-align: center;
        }

        .totalCagnotte {
            text-align: center;
        }
    }

    @media screen and (max-width: ${props => props.theme.mobile}) {
        .valid.header,
        .valid.bloc,
        .pending.bloc,
        .valid.footer,
        .pending.header,
        .pending.footer {
            width: 100%;
        }
        #historique-achat-table.table {
            margin: 0;
            border: 3px solid ${props => props.theme.accountCashbackTableBorderColor};
        }
        #historique-achat-table .enteteTdTableBas.beige-opacite {
            width: 60px;
        }
        #historique-achat-table thead th:first-child {
            width: 75px;
            text-align: center;
        }
        #historique-achat-table thead tr th:last-child {
            padding: 0;
            width: 40px;
        }
        #historique-achat-table thead tr th {
            padding: 15px 5px;
            border: none;
        }
        #historique-achat-table td {
            border: none;
            font-size: 12px;
            text-align: center;
            padding: 15px 5px;
        }
        .legendeLb p {
            width: 75%;
        }
        .legendeLb svg {
            align-self: flex-start;
        }
        .info-compte {
            padding: 20px;
        }

        .marchandTh {
            width: 100px;
            text-align: center;
        }
        .gainsTh {
            text-align: center;
        }

        #bt-voir-plusgains {
            margin-top: 2rem;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/AccountPurchaseStyle.js